import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/savings/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/savings/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/savings/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/savings/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/savings/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/savings` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/savings?title=${title}` , { headers: authHeader() });
};

const SavingsService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default SavingsService;
